module.exports = __webpack_public_path__ + "static/media/card.c4676a53.svg";